import { IAIWorkspaceRequest } from "@entities/aiWorkspace";
import { assetsFromDraft } from "./DraftVetTab/DraftAssetPreview";
import { creatorsFromRequest } from "./ScriptGenerationTab/creatorsFromRequest";
import { promptToText } from "./WorkspacePromptEditor/promptToText";

function firstLine(value: string) {
  return (
    promptToText(value)
      .split("\n")
      .map((line) => line.trim())
      .find((line) => line.length > 0) || ""
  );
}

function trimmedScript(value: string) {
  const line = firstLine(value);
  return line.length > 72 ? `${line.slice(0, 72).trimEnd()}…` : line;
}

export function requestRowCopy(item: IAIWorkspaceRequest) {
  const prompt = firstLine(item.masterPrompt || "");
  if (item.type === "script-vet") {
    return {
      title:
        trimmedScript(item.scripting?.concept || "") ||
        trimmedScript(item.scripting?.title || "") ||
        "Untitled script",
      subtitle: prompt,
    };
  }
  if (item.type === "draft-vet") {
    const count = assetsFromDraft(item.drafting).length;
    return {
      title: count === 1 ? "1 media asset" : `${count} media assets`,
      subtitle: prompt,
    };
  }
  if (item.type === "creator-fit") {
    const count = item.creatorFitChecks?.length || 0;
    return {
      title: `Creator fit check (${count} ${count === 1 ? "creator" : "creators"})`,
      subtitle: "",
    };
  }
  if (item.type === "script-generate") {
    const count = creatorsFromRequest(item).length;
    return {
      title: `Script generation (${count} ${count === 1 ? "creator" : "creators"})`,
      subtitle: "",
    };
  }
  return { title: "Untitled Request", subtitle: prompt };
}
